export enum AuthorityEmployee {
  ENABLE_EMPLOYEE_ACCESS_IN_YARD_MANAGEMENT = '1.2.7',
  REGISTER_EMPLOYEE_READJUST_SALARY = '1.2.6',
  REGISTER_EMPLOYEE_REPORTS = '1.2.5',
  REGISTER_EMPLOYEE_EDIT = '1.2.4',
  REGISTER_EMPLOYEE_DELETE = '1.2.3',
  REGISTER_EMPLOYEE_ADD = '1.2.2',
  REGISTER_EMPLOYEE_VIEW = '1.2.1',
  REGISTER_EMPLOYEE_REGISTRATION = '1.2',
}
